import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { syncNativeNotificationBadge } from '../lib/notification-count';
import { fetchNotificationUnreadCount } from '../lib/notifications-api';
import { QUERY_KEYS } from '../lib/query-keys';

export function useNotificationUnreadCount() {
  // Socket NOTIFICATION_COUNT events keep the cache authoritative: REST
  // fires once per cache entry; gcTime: Infinity keeps the cache pinned.
  const { data, refetch } = useQuery({
    queryKey: QUERY_KEYS.NOTIFICATION_UNREAD_COUNT,
    queryFn: fetchNotificationUnreadCount,
    staleTime: Infinity,
    gcTime: 1000 * 60 * 60,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (typeof data === 'number') {
      syncNativeNotificationBadge(data);
    }
  }, [data]);

  return { count: data ?? 0, refresh: refetch };
}
